<div [ngClass]="{'td-wb-expandable-panel__divider': hasDivider()}">
  <div class="td-wb-expandable-panel__header"
       [ngClass]="{'td-wb-expandable-panel__header--no-padding': noPadding()}">
    <a [ngClass]="{'td-wb-expandable-panel__extended': isExtended()}"
       role="button"
       class="td-wb-expandable-panel__header-toggle"
       (click)="toggleIcon()"
       [attr.aria-expanded]="iconExpanded()"
       href="">
      <div class="td-wb-expandable-panel__header-label">
        @if (!isInline() && !isExtended()) {
          <td-wb-icon size="24"
                      [iconId]="getToggleIconId()"
                      iconType="primary" />
        }
        <ng-content select="[td-wb-expandable-label]" />
        @if (isExtended()) {
          <span class="td-wb-expandable-panel__arrow">
              <td-wb-icon size="24"
                          [iconId]="getToggleIconId()"
                          [iconType]="iconColour()" />
            </span>
        }
        @if (isInline()) {
          <span class="td-wb-expandable-panel__arrow">
              <td-wb-icon size="8"
                          [iconId]="getToggleIconId()"
                          [inline]="true"
                          [iconType]="iconColour()" />
            </span>
        }
      </div>
    </a>
  </div>
  @if (iconExpanded()) {
    <div class="td-wb-expandable-panel__content"
         [ngClass]="{'td-wb-expandable-panel__content--white' : panelBackgroundColour() === 'white',
                     'td-wb-expandable-panel__content--grey' : panelBackgroundColour() === 'grey',
                     'td-wb-expandable-panel__content--clear' : panelBackgroundColour() === 'clear',
                     'td-wb-expandable-panel__content--accordion' : iconType() === 'circle',
                     'td-wb-expandable-panel__content--tint' : panelBackgroundColour() === 'tint',
                     'td-wb-expandable-panel__content--no-padding' : noPadding(),
                     'td-wb-expandable-panel__content--trailing' : isExtended() }">
      <ng-content />
    </div>
  }
</div>
